import { useParams } from "react-router-dom";
import { apiService } from "@services/ApiService";
import { bucketName } from "@utils/baseValues";

interface UploadResponse {
  filename: string;
  size: number;
  filetype: string;
  id: string;
  owner: {
    id: string;
    email: string;
    first_name: string;
    last_name: string;
    is_superuser: boolean;
    use_ext_template: unknown;
  };
  s3_url: string;
  uploaded_at: string;
}

class EditorImageUploader {
  private uploadUrl: string;

  constructor(projectId: string, reportId: string) {
    if (!projectId || !reportId) {
      throw new Error("Project ID or Report ID is missing from the URL.");
    }

    this.uploadUrl = `/projects/${projectId}/${reportId}/add-image/`;
  }

  async uploadByFile(
    file: File
  ): Promise<{ success: number; file?: { url: string }; message?: string }> {
    const formData = new FormData();
    formData.append("uploaded_file", file);

    try {
      const response = await apiService.post(this.uploadUrl, formData);
      const data: UploadResponse = response;

      if (!data.s3_url) {
        throw new Error("Invalid response from server");
      }

      // Construct the full S3 URL
      const imageUrl = `https://${bucketName}.s3.eu-central-1.amazonaws.com/${data.s3_url}`;

      return {
        success: 1,
        file: {
          url: imageUrl,
        },
      };
    } catch (error) {
      console.error("Error uploading image to S3:", error);
      return { success: 0, message: "Image upload failed" };
    }
  }
}

const createEditorImageUploader = (): EditorImageUploader => {
  const { projectId, reportId } = useParams<{
    projectId: string;
    reportId: string;
  }>();

  if (!projectId || !reportId) {
    throw new Error("Project ID or Report ID is missing from the URL.");
  }

  return new EditorImageUploader(projectId, reportId);
};

export { EditorImageUploader as S3ImageUploader, createEditorImageUploader };
